(function() {
    let menuSuperior = document.getElementsByClassName("menu-superior")[0];
    let menuPrincipal = document.getElementsByClassName("menu-principal")[0];
    let desplegables = menuPrincipal.getElementsByClassName("dropdown-content");
    let btnUsuario = document.querySelector(".btn-usuario");
    let btnIdioma = document.querySelector(".idioma-btn-menu");

    menuSuperior.querySelector(".menu-toggle").addEventListener("click", function (e) {
        e.target.classList.toggle("abierto");
        menuPrincipal.classList.toggle("abierto");
        document.querySelector(".ctr-menus").classList.toggle("abierto");

        if (!e.target.classList.contains('abierto')) {
            for (let desplegable of desplegables) {
                desplegable.style.maxHeight = null;
            }
        }
    }, false);

    let mqLG = window.matchMedia( "(min-width: 1024px)" );

    menuPrincipal.addEventListener("click", (e) => {
        if(!mqLG.matches && e.target && e.target.tagName === "A" && e.target.classList.contains('item-main') && e.target.parentElement.parentElement.classList.contains('dropdown')) {
            e.preventDefault();

            let panel = e.target.parentElement.nextElementSibling;
            for (let desplegable of desplegables) {
                if (desplegable !== panel) {
                    desplegable.style.maxHeight = null;
                }
            }

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        }
    })

    window.addEventListener('resize', (e) => {
        if (mqLG.matches) {
            for (let desplegable of desplegables) {
                desplegable.style.maxHeight = null;
            }

            menuSuperior.getElementsByClassName("menu-toggle")[0].classList.remove("abierto");
            menuPrincipal.classList.remove("abierto");

            if (btnUsuario) {
                btnUsuario.classList.remove("abierto");
            }
        }
    });

    if (btnUsuario) {
        btnUsuario.addEventListener("click", (e) => {
            btnUsuario.classList.toggle("abierto");
        });
    }

    if (btnIdioma) {
        btnIdioma.addEventListener("click", (e) => {
            btnIdioma.classList.toggle("abierto");
        });
    }
})();
